(function(config) {
    'use strict';

    angular.module('caffeprint')
        .filter('cpImageRender', cpImageRender);

    cpImageRender.$inject = [];

    function cpImageRender() {
        return function(item, width, height, type) {
            return config.api + '/image-render/' + type + '/' + width + '/' + height + '/' + item.pk;
        };
    }
})(window.config);
